/**
 * editor_plugin_src.js
 *
 * Copyright 2009, Moxiecode Systems AB
 * Released under LGPL License.
 *
 * License: http://tinymce.moxiecode.com/license
 * Contributing: http://tinymce.moxiecode.com/contributing
 */
import window from 'window-or-global';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

/**
 * Auto Resize
 *
 * This plugin automatically resizes the content area to fit its content height.
 * It will retain a minimum height, which is the height of the content area when
 * it's initialized.
 */
const plugger = {
	/**
	 * Initializes the plugin, this will be executed after the plugin has been created.
	 * This call is done before the editor instance has finished it's initialization so use the onInit event
	 * of the editor instance to intercept that event.
	 *
	 * @param {window.tinymce.Editor} ed Editor instance that the plugin is initialized in.
	 */
	init(ed) {
		ed.on('Init', () => {
			// ATLASSIAN
			ed.getBody().classList.add('resizable');
		});

		let oldSize = 0;

		if (ed.getParam('fullscreen_is_enabled')) {
			return;
		}

		// Define minimum height
		const autoresize_min_height = parseInt(
			ed.getParam('autoresize_min_height', ed.getElement().offsetHeight),
		);

		// Define maximum height
		const autoresize_max_height = parseInt(ed.getParam('autoresize_max_height', 0));

		/**
		 * This method gets executed each time the editor needs to resize.
		 * @param obj This can be Editor object if function is invoked from an event OR object that is passed as 2nd param to execCommand
		 */
		function resize(obj) {
			const doc = ed.getDoc();
			const body = doc.body;
			const docEl = doc.documentElement;
			const DOM = window.tinymce.DOM;
			let resizeHeight = autoresize_min_height;
			const force = obj === Object(obj) ? obj.forceExec || false : false;

			// ATLASSIAN - Use jquery to work out height
			const myHeight = $(doc).height();
			// Get height differently depending on the browser used
			// myHeight = myHeight = window.tinymce.isIE ? body.scrollHeight : (window.tinymce.isWebKit && body.clientHeight == 0 ? 0 : body.offsetHeight);

			// Don't make it smaller than the minimum height
			if (myHeight > autoresize_min_height) {
				resizeHeight = myHeight;
			}

			// If a maximum height has been defined don't exceed this height
			if (autoresize_max_height && myHeight > autoresize_max_height) {
				resizeHeight = autoresize_max_height;
				body.style.overflowY = 'auto';
				docEl.style.overflowY = 'auto'; // Old IE
			} else {
				body.style.overflowY = 'hidden';
				docEl.style.overflowY = 'hidden'; // Old IE
				body.scrollTop = 0;
			}

			// Resize content element
			if (force || resizeHeight !== oldSize) {
				const deltaSize = resizeHeight - oldSize;
				DOM.setStyle(DOM.get(`${ed.id}_ifr`), 'height', `${resizeHeight}px`);
				oldSize = resizeHeight;

				// WebKit doesn't decrease the size of the body element until the iframe gets resized
				// So we need to continue to resize the iframe down until the size gets fixed
				if (window.tinymce.Env.webkit && deltaSize < 0) {
					resize();
				}
			}
		}

		// ATLASSIAN - not needed and causes editor to grow on each key press.
		//          // Add padding at the bottom for better UX
		//          ed.onInit.add(function(ed){
		//              ed.dom.setStyle(ed.getBody(), 'paddingBottom', ed.getParam('autoresize_bottom_margin', 50) + 'px');
		//          });

		// Add appropriate listeners for resizing content area
		ed.on('Change SetContent Paste KeyUp Init', resize);

		/*
        This code cause content of editor to be empty.
        Revisit it if we catch a bug with autoresize
        if (ed.getParam('autoresize_on_init', true)) {
            ed.on('Load LoadContent', resize);
        }*/

		// Register the command so that it can be invoked by using window.tinymce.activeEditor.execCommand('mceAutoResize');
		ed.addCommand('mceAutoResize', resize);
	},

	/**
	 * Returns information about the plugin as a name/value array.
	 * The current keys are longname, author, authorurl, infourl and version.
	 *
	 * @return {Object} Name/value array containing information about the plugin.
	 */
	getInfo() {
		return {
			longname: 'Auto Resize',
			author: 'Moxiecode Systems AB',
			authorurl: 'http://tinymce.moxiecode.com',
			infourl: 'http://wiki.moxiecode.com/index.php/TinyMCE:Plugins/autoresize',
			version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
		};
	},
};

export default function () {
	window.tinymce.create('tinymce.plugins.AutoResizePlugin', plugger);

	// Register plugin
	window.tinymce.PluginManager.add('autoresize', window.tinymce.plugins.AutoResizePlugin);
}
